export { VersionItem as default };

/**
* Version Entity
*
* @author      rsommerfeld <roni.s.sommerfeld@altice.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class VersionItem {
  /**
   * Object that contains PTMail versions
   *
   * @public
   *
   * @type {Object}
   * @property {String} js - identifies the js version
   *
   * @since 7.0.0
   */
  version = {
    js: null
  }

  /**
   * Identifies whether the version warning is
   * visible or not
   *
   * @public
   *
   * @type {Boolean}
   *
   * @since 7.0.0
   */
  is_warning_visible = false;
}